import { Injectable } from '@angular/core';
import { NavigationExtras, Params, Router } from '@angular/router';
import { ViewportService } from '@core/services/viewport.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(
    private _router: Router,
    private _viewportService: ViewportService,
  ) {}

  public navigate(
    route: Array<any>,
    extras?: NavigationExtras,
    scrollToTop: boolean = true,
  ): Promise<boolean> {
    return this._router.navigate(route, extras).then((success) => {
      if (success && scrollToTop) this._viewportService.scrollToPosition([0, 0]);
      return success;
    });
  }

  public navigateToUrl(url: string, scrollToTop: boolean = true): Promise<boolean> {
    const parsedUrl = new URL(url);
    const queryParams: Params = {};
    parsedUrl.searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });

    return this._router
      .navigate([parsedUrl.pathname], {
        queryParams,
      })
      .then((success) => {
        if (success && scrollToTop) this._viewportService.scrollToPosition([0, 0]);
        return success;
      });
  }

  // TODO: Deprecate method
  public navigateUrlWithPersistence(route: string[], extras?: NavigationExtras): void {
    this._router.navigate(route, { ...extras, queryParamsHandling: 'merge' });
  }
  // TODO: Deprecate method
  public navigateUrlWithoutPersistence(route: string[], extras?: NavigationExtras): void {
    this._router.navigate(route, extras);
  }

  public navigateExternalUrl(url: string, target: '_blank' | '_self' | '_parent' | '_top'): void {
    window.open(url, target);
  }
}
